import { useState, useEffect } from 'react';
import { IconClose, IconHamburger, LogoIcon } from '@components/icons';
// import DarkMode from './DarkMode';
import { LogoBlue } from '@components/icons';
import { useRouter } from 'next/router';
import {
  Nav,
  LogoWrapper,
  Hamburger,
  ModalWrapper,
  LinksWrapper,
  StyledLink,
  StyledSpan,
  StyledEm,
  TabletWrap,
  MobileWrap,
} from './NavbarTablet.styles';
import Link from 'next/link';
import Container from '@components/common/Container';
import ConnectWalletButton from '@components/common/navbar/ConnectWalletButton';

export default function NavbarTablet() {
  const router = useRouter();
  const [menu, setMenu] = useState(false);
  const toggleMenu = () => {
    setMenu(!menu);
  };
  useEffect(() => {
    const handleRouteChange = () => setMenu(false);
    router.events.on('routeChangeComplete', handleRouteChange);
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, []);
  return (
    <Nav>
      <LogoWrapper>
        <Link href="/">
          <TabletWrap>
            <LogoBlue />
          </TabletWrap>
          <MobileWrap>
            <LogoIcon />
          </MobileWrap>
        </Link>
      </LogoWrapper>
      <Hamburger onClick={toggleMenu}>
        {menu && <IconClose />}
        {!menu && <IconHamburger />}
      </Hamburger>
      {menu && <MenuModal />}
    </Nav>
  );

  function MenuModal() {
    const r = useRouter();
    return (
      <ModalWrapper>
        <Container>
          <LinksWrapper>
            <StyledLink href="/open-position" isActive={r.pathname === '/open-position'}>
              <StyledSpan type="span">
                Open Position {r.pathname === '/open-position' && <StyledEm></StyledEm>}
              </StyledSpan>
            </StyledLink>
            <StyledLink href="/earn" isActive={r.pathname === '/earn'}>
              <StyledSpan type="span">Earn {r.pathname === '/earn' && <StyledEm></StyledEm>}</StyledSpan>
            </StyledLink>
            <StyledLink
              href="https://dune.com/archimedesfi/liquidity-provider-dashboard"
              target="_blank"
              rel="noreferrer"
            >
              <StyledSpan type="span">Analytics</StyledSpan>
            </StyledLink>
            <StyledLink href="/dashboard" isActive={r.pathname === '/dashboard'}>
              <StyledSpan type="span">My Dashboard {r.pathname === '/dashboard' && <StyledEm></StyledEm>}</StyledSpan>
            </StyledLink>
          </LinksWrapper>
          <ConnectWalletButton />
        </Container>
      </ModalWrapper>
    );
  }
}
